"use strict";

import Dom from "common/Dom";
import slickCarousel from "slick-carousel";
export const initSliders = function initSliders() {
  $(Dom.slickSlider).slick();
};
